// extracted by mini-css-extract-plugin
export default {"nav":"reducedNavbar_nav__DjRf8","logo":"reducedNavbar_logo__huixc","logoutBtn":"reducedNavbar_logoutBtn__Ocguv","logoutImage":"reducedNavbar_logoutImage__lcjPg"};